import { CompartilharVideochamadaModel } from 'components/videochamada/CompartilharVideochamadaForm'
import { createValidator, email, required } from 'util/validation'

export const validateCompartilharVideochamada = createValidator<CompartilharVideochamadaModel>({
  emailDestinatario: [email, required],
})
